/**
 * Strip deprecated restaurant fields that should come from Google Place Details
 * via `googlePlaceId` instead of the database.
 */
export function omitDeprecatedRestaurantPlaceFields(restaurant) {
  if (!restaurant || typeof restaurant !== "object") return restaurant;
  const { address: _a, openingHours: _h, ...rest } = restaurant;
  return rest;
}
